<section class="operations-page">
    <header class="operations-page__header">
        <div>
            <h2 class="operations-page__title">Vehicle Transactions</h2>
            <p class="operations-page__lead">Server-paginated VTE lifecycle visibility for platform diagnostics.</p>
        </div>
    </header>

    <div class="operations-page__card">
        <app-filter-bar
                [filters]="filterDefinitions"
                [values]="filterValues"
                (apply)="onFiltersApply($event)"
                (reset)="onFiltersReset()"
        ></app-filter-bar>

        <p class="operations-page__loading" *ngIf="listState.loading">Loading transactions…</p>

        <div class="operations-table-wrapper" *ngIf="!listState.loading">
            <table class="operations-table">
                <thead>
                <tr>
                    <th>S.No</th>
                    <th class="operations-table__sortable" (click)="onSort('correlated_plate')">
                        Vehicle Number
                        <span class="sort-indicator">{{ sortIndicator('correlated_plate') }}</span>
                    </th>
                    <th *ngIf="showOrganizationColumn">Organization</th>
                    <th class="operations-table__sortable" (click)="onSort('anchor_timestamp')">
                        Anchor Time
                        <abbr *ngIf="columnHelp({helpKey: 'anchor'}) as help"
                              class="operations-table__help" [title]="help">ⓘ</abbr>
                        <span class="sort-indicator">{{ sortIndicator('anchor_timestamp') }}</span>
                    </th>
                    <th class="operations-table__sortable" (click)="onSort('created_at')">
                        Created
                        <abbr *ngIf="columnHelp({helpKey: 'created'}) as help"
                              class="operations-table__help" [title]="help">ⓘ</abbr>
                        <span class="sort-indicator">{{ sortIndicator('created_at') }}</span>
                    </th>
                    <th class="operations-table__sortable" (click)="onSort('status')">
                        Status
                        <span class="sort-indicator">{{ sortIndicator('status') }}</span>
                    </th>
                    <th>Camera</th>
                    <th>Analytics</th>
                    <th class="operations-table__actions"></th>
                </tr>
                </thead>
                <tbody>
                <tr *ngIf="!transactions.length">
                    <td [attr.colspan]="showOrganizationColumn ? 9 : 8" class="operations-table__empty">No transactions
                        found.
                    </td>
                </tr>
                <tr *ngFor="let transaction of transactions; let i = index">
                    <td>{{ serialNumber(i) }}</td>
                    <td>{{ transaction.correlated_plate || '—' }}</td>
                    <td *ngIf="showOrganizationColumn">{{ organizationLabel(transaction.organization_id) }}</td>
                    <td>{{ formatTimestamp(transaction.anchor_timestamp) }}</td>
                    <td>{{ formatTimestamp(transaction.created_at) }}</td>
                    <td>
                        <div class="operations-status-badges">
                            <app-transaction-status-badge [status]="transaction.status"></app-transaction-status-badge>
                            <app-operational-attention-badge
                                    [transaction]="transaction"></app-operational-attention-badge>
                        </div>
                    </td>
                    <td>{{ transaction.camera_id ?? '—' }}</td>
                    <td>
                        <div class="operations-facts">
                            <div class="operations-fact-item" *ngFor="let fact of previewFacts(transaction)">
                                <span class="operations-fact-item__label">{{ fact.label || fact.output_fact }}</span>
                                <app-analytics-fact-renderer [fact]="fact"></app-analytics-fact-renderer>
                            </div>
                            <span *ngIf="!previewFacts(transaction).length" class="operations-page__muted">—</span>
                        </div>
                    </td>
                    <td class="operations-table__actions">
                        <a class="operations-table__link"
                           [routerLink]="['/operations/transactions', transaction.transaction_id]"
                           [queryParams]="listQueryParams">View</a>
                    </td>
                </tr>
                </tbody>
            </table>

            <app-vte-pagination
                    [currentPage]="listState.currentPage"
                    [pageSize]="listState.pageSize"
                    [totalRecords]="listState.totalRecords"
                    [showJumpToPage]="true"
                    (pageChange)="onPageChange($event)"
                    (pageSizeChange)="onPageSizeChange($event)"
            ></app-vte-pagination>
        </div>
    </div>
</section>
